import React from 'react';
import './Banner.css';
import Stars from './Stars';

function Banner() {
    return (
        <div className="banner-bg">
            <Stars></Stars>
            <div className="banner">
                <h1 className='banner-text'>Hey, I'm Tim</h1>
                <div id="banner-line"></div>
                <p className='banner-subtext'>I love learning new technologies and building awesome stuff with it.</p>
            </div>
        </div >
    );
}

export default Banner;